import React, { useMemo } from 'react';

import { CircularProgress, useTheme } from '@material-ui/core';

interface Props {
  loading: boolean;
  title: string;
  loaderVariant: 'primary' | 'paper';
  size?: number;
}

export const ButtonTitleWithLoading: React.FC<Props> = ({ loading, title, loaderVariant, size = 26.25 }) => {
  const theme = useTheme();

  const color = useMemo(() => {
    switch (loaderVariant) {
      case 'paper':
        return theme.palette.background.paper;
      case 'primary':
        return theme.palette.primary.main;
    }
  }, [loaderVariant]);

  return <>{loading ? <CircularProgress size={size} style={{ color }} /> : title}</>;
};
